import { memo } from "react";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { TaskPreviewRow } from "../taskPreviewViewConfig";
import { HStack } from "@design-system/HStack/HStack";

interface Props {
    row: { original: TaskPreviewRow };
    getValue: () => string;
}

export const TaskPreviewAssigneeCell = memo(function TaskPreviewAssigneeCell({
    row,
    getValue,
}: Readonly<Props>) {
    if (row.original.isGroupRow) {
        return null;
    }
    const displayName = getValue() ?? "";
    const user = row.original.assigneeUser;
    return (
        <ViewTableCell>
            <HStack gap={8} align="center">
                {user != null && (
                    <UserAvatar user={user} size="sm" aria-hidden />
                )}
                <span>{displayName}</span>
            </HStack>
        </ViewTableCell>
    );
});
